import { render, staticRenderFns } from "./PacientesInfoGeneral.vue?vue&type=template&id=a299a792"
import script from "./PacientesInfoGeneral.vue?vue&type=script&lang=js"
export * from "./PacientesInfoGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports